import React, { useEffect, useState, useRef } from "react";
import {
  I2cAlert,
  I2cDataTable,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useNavigate, useLocation } from "react-router-dom";
function DataTable(props) {
  const {
    setCurrentPage,
    currentPage,
    rowData,
    columnDefs,
    pageSize,
    total,
    tableDataApiInternal,
    tableDataApiExternal,
    tableDataApi,
    closeModal,
    onAssign,
    noData,
    rowSelection,
  } = props;
  const [rowDataa, setRowDataa] = useState(rowData);
  const [gridOptions, setGridOptions] = useState({});
  const confirm_btn = useRef(null);
  const navigate = useNavigate();
  const [alertMsg, setAlertMsg] = useState("");
  const [alertState, setAlertState] = useState(false);
  const noDataMessage = [
    {
      heading: "Something went wrong...",
      description:
        "We had some trouble loading this page. Please refresh the page to try again or get in touch if the problem sticks around!",
      type: "noData",
      icon: "outline-info-circle",
    },
    {
      heading: "No vendors found",
      description:
        "Your search $filterText did not match any vendors. Please try again or create add a new vendor.",
      type: "noSearch",
      secondaryBtn: `<i2c-button variant="secondary gray" size='large' part="clearbutton" class="clear-btn">Clear search</i2c-button>`,
      primaryBtn: `<i2c-button variant="primary"  size='large'>New project</i2c-button>`,
    },
  ];

  const css = ` 
    .header-right
      {
        display:flex;
        gap:var(--i2c-spacing-3);
        flex-wrap:wrap;
      }
      
      i2c-data-table{
        max-width: 100%;
        display: block;
        --ag-grid--shadow: 0 0 0;
        --pagination-padding: var(--i2c-spacing-3) 0 
      }
      i2c-section-header{
        --sec-header-padding:var(--i2c-spacing-4) var(--i2c-spacing-6) var(--i2c-spacing-4);
        --sec-header-margin:0;
        --sec-header-parent-space:0;
        --sec-title-container-gap:0.563rem;
      }
      i2c-section-header::part(badge)
      {
        padding-bottom:0.25rem;
      }
      i2c-section-header::part(sec-head-header)
      {
        border:0;
      } 
      i2c-pagination{
        --pagination-padding: var(--i2c-spacing-3) 0  
      }
      `;
  const handleGridApi = async (data) => {
    try {
      const gridApi = await tableDataApi?.current.getGridApi();
      // console.log("tableData", gridApi)
      gridApi.updateGridOptions({ rowData: data }); 
    } catch (error) {
      console.warn('Error getting grid API:', error);
    }
  };
  useEffect(() => {
    if (props.rowData.length !== 0) {
      setGridOptions({
        columnDefs: columnDefs,
        rowSelection: rowSelection,
        rowData: rowDataa?.length !== 0 ? rowDataa : [],
        suppressMoveWhenRowDragging: true,
        suppressMovableColumns: true,
      });
    } else {
      setGridOptions({
        columnDefs: columnDefs,
        rowSelection: rowSelection,
        rowData: false,
        suppressMoveWhenRowDragging: true,
        suppressMovableColumns: true,
      });
    }
    handleGridApi(rowDataa)
    // const api = tableDataApi?.current?.getGridApi();
    // console.log("tableData", tableDataApi)
    // if (api) {
    //   api.setRowData && api.setRowData(rowDataa?.length !== 0 ? rowDataa : []);
    // }
  }, [rowDataa]);

  useEffect(() => {
    setRowDataa(rowData.length ? rowData : []);
  }, [rowData]);

  const handlePageChange = (e) => {
    setCurrentPage &&
      setCurrentPage(e?.target?.tablePagination?.currentPage ?? 1);
  };

  useEffect(() => {
    const tableRef = tableDataApi?.current;
    if (tableRef) {
      tableRef.addEventListener("i2c-page-change", handlePageChange);
      return () => {
        tableRef.removeEventListener("i2c-page-change", handlePageChange);
      };
    }
  }, [tableDataApi]);

  return (
    <>
      {/* error message starts */}
      <I2cAlert
        open={alertState ? true : false}
        className="alert"
        variant="danger"
        type="plain"
        layout="layoutAsideLeft"
        headerArt="cs-linear-alert-circle"
      >
        <span slot="label">{alertMsg}</span>
      </I2cAlert>
      <I2cDataTable
        id="dataTable1"
        gridOptionInput={gridOptions}
        notFound={noData}
        headerBlock
        gridBorder
        paginationEnable
        currentPage={currentPage ?? 1}
        pageSize={pageSize ?? 6}
        totalCount={total ?? 6}
        ref={tableDataApi}
      ></I2cDataTable>

      {/* <footer slot="footer">
        <I2cButton slot="footer" variant="secondary gray" onClick={closeModal}>
          Cancel
        </I2cButton>
        {rowDataa?.length !== 0 && (
          <I2cButton
            slot="footer"
            variant="primary"
            onClick={() => {
              const api = table.current.getGridApi();
              const selectedNodes = api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              onAssign(selectedRows);
            }}
          >
            Assign
          </I2cButton>
        )}
      </footer> */}
      <style>{css}</style>
    </>
  );
}
export default DataTable;
